export default "__VITE_ASSET__41bfea7c__"